module.exports = __webpack_public_path__ + "media/images/icons/business-a8340e9fbf472e6f319cd835c0dc2745.svg";